// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  padding: 0 15px;
}

.imgEstadoCielo {
  width: 2em;
  height: 2em;
}

.tiempo {
  display: flex;
  flex-direction: row;
  align-items: center;
  float: left;
}
.tiempo * {
  margin: 0;
  padding: 0;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cart {
  display: flex;
  flex-direction: row;
  align-items: center;
  float: right;
}
.cart * {
  margin: 0;
  padding: 0;
}

.icono {
  padding-top: 5px;
}

.badge {
  position: absolute;
  z-index: 999;
  right: -5px;
  font-size: 12px;
}

.conexion {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

ion-icon {
  font-size: 16px;
}

.nombre_empresa_movil {
  color: "primary";
  font-weight: bold;
}

.nombre-empresa-desktop {
  font-size: x-large !important;
  font-weight: bold;
  color: "primary" !important;
}

@media (max-width: 500px) {
  .ellipsis {
    max-width: 160px;
  }
}
@media (prefers-color-scheme: dark) {
  img.dark-theme {
    src: url('logo_alosuite_blanco.png');
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/barra-superior/barra-superior.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACC,UAAA;EACA,WAAA;AACD;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AACD;AACE;EACE,SAAA;EACA,UAAA;AACJ;;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAF;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAAD;AAEE;EACE,SAAA;EACA,UAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AADF;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;;AAIE;EACE,eAAA;AADJ;;AAIE;EACE,gBAAA;EACA,iBAAA;AADJ;;AAYE;EACE,6BAAA;EACA,iBAAA;EAEA,2BAAA;AAVJ;;AAcA;EACE;IACE,gBAAA;EAXF;AACF;AAcA;EACE;IACE,oCAAA;EAZF;AACF","sourcesContent":["ion-grid {\r\n  padding: 0 15px;\r\n}\r\n\r\n.imgEstadoCielo {\r\n\twidth: 2em;\r\n\theight: 2em;\r\n}\r\n\r\n.tiempo {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-items: center;\r\n\tfloat: left;\r\n\r\n  * {\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.ellipsis {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.cart {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-items: center;\r\n\tfloat: right;\r\n\r\n  * {\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.icono {\r\n  padding-top: 5px;\r\n}\r\n\r\n.badge {\r\n  position: absolute;\r\n  z-index: 999;\r\n  right: -5px;\r\n  font-size: 12px;\r\n}\r\n\r\n.conexion {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n  ion-icon {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .nombre_empresa_movil {\r\n    color: 'primary'; \r\n    font-weight: bold;\r\n\r\n\r\n  }\r\n\r\n  // img.dark-theme {\r\n\r\n  //     src : url('../../../assets/imagenes/iconos/logo_alosuite_blanco.png');\r\n    \r\n  // }\r\n\r\n  .nombre-empresa-desktop {\r\n    font-size: x-large !important;\r\n    font-weight: bold;\r\n    //text-shadow: 2px 2px 4px #9da5a2;\r\n    color: 'primary' !important; \r\n  }\r\n\r\n\r\n@media (max-width: 500px) {\r\n  .ellipsis {\r\n    max-width: 160px;\r\n  }\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n  img.dark-theme {\r\n    src : url('../../../assets/imagenes/iconos/logo_alosuite_blanco.png');\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
